export default __webpack_public_path__ + "static/media/Calendar-green.6b5ed12c.svg";